import React from 'react';
import SimpleFilter from './simple-filter'

const GroupFilter = ({filter, indexTop, allColumns, updateColumn, regionsAndLocations, updateType,
                      updateCondition, updateValue, updateDateConditionChild, updateNumberCondition,
                      onDeleteFilter, addCondition, addConditionGroup}) => {
  return <tr key={indexTop}>
    <td>
      <div className='col-sm-1 text-left zero-padding-x'>
        {!(indexTop.length == 1 && indexTop[0] == 0) ?
          <select value={filter.type} onChange={e=> updateType(e.target.value, indexTop)}>
          { ['and','or'].map((o, i) => <option key={i} value={o}>{o}</option>) }
          </select> : <span>Where</span>
        }
      </div>
      <div className='col-sm-11 zero-padding-right zero-padding-x'>
        <table className='table table-bordered text-right'>
          <tbody>
            <tr>
              <td>
                <div className='col-sm-10 text-left'>Any of the following are true... </div>
                <div className='col-sm-2 text-right'>
                  { indexTop.length < 3 &&
                    <span className='fa fa-list' onClick={() => addConditionGroup([...indexTop])}></span>
                  }&nbsp;
                  <span className='fa fa-plus-circle' onClick={() => addCondition([...indexTop])}></span>&nbsp;
                  <span className='fa fa-trash' onClick={() => onDeleteFilter([...indexTop])}></span>
                </div>
              </td>
            </tr>
          {filter.items.length > 0 && filter.items.map(
            (filterIn, index) => filterIn.group ?
              <GroupFilter
                key={index}
                filter={filterIn}
                indexTop={[...indexTop, index]}
                allColumns={allColumns}
                updateColumn={updateColumn}
                regionsAndLocations={regionsAndLocations}
                updateType={updateType}
                updateCondition={updateCondition}
                updateValue={updateValue}
                updateDateConditionChild={updateDateConditionChild}
                updateNumberCondition={updateNumberCondition}
                onDeleteFilter={onDeleteFilter}
                addCondition={addCondition}
                addConditionGroup={addConditionGroup}
              /> :
              <SimpleFilter
                key={index}
                filter={filterIn}
                i={[...indexTop, index]}
                allColumns={allColumns}
                updateColumn={updateColumn}
                regionsAndLocations={regionsAndLocations}
                updateType={updateType}
                updateCondition={updateCondition}
                updateValue={updateValue}
                updateDateConditionChild={updateDateConditionChild}
                updateNumberCondition={updateNumberCondition}
                onDeleteFilter={onDeleteFilter}
              />
            )
          }
          </tbody>
        </table>
      </div>
    </td>
  </tr>
}

export default GroupFilter
